/* eslint-disable object-curly-spacing */
export default ({authGuard, guestGuard}) => [

  {
    path: '/',
    name: 'startseite',
    component: require('~/pages/startseitevuex.vue').default
  },
  {
    path: '/lokal',
    name: 'lokal',
    component: require('~/pages/lokal/lokalstart.vue').default
  },
  {
    path: '/handwerker',
    name: 'handwerker',
    component: require('~/pages/leistungliste/ListingStart.vue').default
  },
  {
    path: '/pionierestart',
    name: 'pionierestart',
    component: require('~/pages/leistungliste/PioniereStart.vue').default
  },
  // {
  //   path: '/in-der-nähe',
  //   name: 'indernaehe',
  //   component: require('~/pages/indernaehe/naehestart.vue').default
  // },
  {
    path: '/impressum',
    name: 'impressum',
    component: require('~/pages/impressum.vue').default
  },
  {
    path: '/datencheck/:id',
    name: 'datencheck',
    component: require('~/pages/leistungenedit/confirm.vue').default
  },
  {
    path: '/solarteurbla/:id',
    name: 'solarteurbla',
    component: require('~/pages/leistungenedit/confirm.vue').default
  },
  // { path: '/newprofile', name: 'newprofile', component: require('~/pages/companies/showCompanyPrem.vue') },

  {
    path: '/betrieb/:id',
    name: 'showCompany',
    component: require('~/pages/companies/showCompany.vue').default
  },
  // {
  //   path: '/stellen',
  //   name: 'stellen',
  //   component: require('~/pages/stellen/StellenStart.vue').default
  // },
  // {
  //   path: '/stelle/:id',
  //   name: 'stellenanzeige',
  //   component: require('~/pages/stellen/StelleDetail.vue').default
  // },
  {
    path: '/gewerke',
    name: 'gewerke',
    component: require('~/pages/gewerke/GewerkStart.vue').default
  },
  {
    path: '/gewerk/:id',
    name: 'gewerkdetail',
    component: require('~/pages/gewerke/GewerkDetail.vue').default
  },
  {
    path: '/kreishandwerkerschaften',
    name: 'khs',
    component: require('~/pages/kreishandwerkerschaft/KHStart.vue').default
  },
  {
    path: '/kh/:id',
    name: 'khdetail',
    component: require('~/pages/kreishandwerkerschaft/KHDetail.vue').default
  },
  {
    path: '/infos/:id',
    name: 'Infos',
    component: require('~/pages/infos/Infos.vue').default
  },

  {
    path: '/testcomp',
    name: 'testcomp',
    component: require('~/pages/testcomp.vue').default
  },
  {
    path: '/gemerkt',
    name: 'gemerkt',
    component: require('~/pages/gemerkt.vue').default
  },
  {
    path: '/sanierung',
    name: 'sanierung',
    component: require('~/pages/sanierung.vue').default
  },
  {
    path: '/wizard/:slug',
    name: 'wizard',
    component: require('~/pages/wizard/wizard.vue').default
  },

  // Authenticated routes.
  ...authGuard([
    {path: '/home', name: 'home', component: require('~/pages/home.vue').default },
    {
      path: '/premium',
      name: 'premium',
      component: require('~/pages/premium.vue').default,
      meta: {scrollTopTop: true}
    },
    {
      path: '/premiumok',
      name: 'premiumok',
      component: require('~/pages/premiumok.vue').default
    },

    {
      path: '/testland',
      name: 'testland',
      component: require('~/pages/testland/testland.vue').default
    },
    // {
    //   path: '/zettel',
    //   name: 'zettel',
    //   component: require('~/components/zettel/ZettelStart.vue').default
    // },
    {
      path: '/kalender',
      name: 'kalender',
      component: require('~/pages/kalender/KalenderStart.vue').default
    },
    {
      path: '/anfragen',
      name: 'anfragen',
      component: require('~/pages/meineanfragen/anfragenindex.vue').default
    },
    {
      path: '/anfrage/:id',
      name: 'anfragedetail',
      component: require('~/pages/meineanfragen/anfragendetail.vue').default
    },

    {
      path: '/nachrichten',
      name: 'nachrichten',
      component: require('~/pages/nachrichten/NachrichtenStart.vue').default
    },
    // {
    //   path: '/kunden',
    //   name: 'kunden',
    //   component: require('~/pages/kunden/kunden.vue').default
    // },
    // {
    //   path: '/forum',
    //   name: 'forum',
    //   component: require('~/pages/forum/forum.vue').default
    // },
    // {
    //   path: '/stellenedit/:id',
    //   name: 'stellenedit',
    //   component: require('~/pages/stellen/StelleEdit.vue').default
    // },
    // package,json removed:
    // "tiptap": "^1.26.4",
    // "tiptap-extensions": "^1.28.4",
    // "tiptap-vuetify": "^1.7.0",
    // {
    //   path: '/neuestelle',
    //   name: 'stelleneu',
    //   component: require('~/pages/stellen/StelleNeu.vue').default
    // },
    // {
      //   path: '/meinestellen',
      //   name: 'meinestellen',
      //   component: require('~/pages/stellen/MeineStellenStart.vue').default
      // },
    // {
    //   path: '/anzeigen/:kategorie?',
    //   name: 'anzeigen',
    //   props: true,
    //   component: require('~/pages/anzeigen/anzeigenstart.vue').default
    // },
    // {
    //   path: '/anzeige/:id',
    //   name: 'anzeigedetail',
    //   component: require('~/pages/anzeigen/AnzeigenDetail.vue').default
    // },
    // {
    //   path: '/anzeigeedit/:id',
    //   name: 'anzeigeedit',
    //   component: require('~/pages/anzeigen/AnzeigenEdit.vue').default
    // },
    {
      path: '/kcheck',
      name: 'kcheck',
      component: require('~/pages/kcheck/kcheckstart.vue').default
    },
    {
      path: '/einstellungen',
      component: require('~/pages/settings/index.vue').default,
      children: [
        {path: '', redirect: {name: 'einstellungen.profil'}},
        {
          path: 'profil',
          name: 'einstellungen.profil',
          component: require('~/pages/settings/profile.vue').default
        },
        {
          path: 'password',
          name: 'einstellungen.password',
          component: require('~/pages/settings/password.vue').default
        }
      ]
    },
    // Mein Betrieb
    {
      path: '/meinbetrieb',
      component: require('~/pages/meinbetrieb/index.vue').default,
      children: [
        {path: '', redirect: {name: 'meinbetrieb.profil'}},
        {
          path: 'profil',
          name: 'meinbetrieb.profil',
          component: require('~/pages/meinbetrieb/profile.vue').default
        },
        {
          path: 'leistungen',
          name: 'meinbetrieb.leistungen',
          component: require('~/pages/meinbetrieb/leistungen.vue').default
        },
        {
          path: 'darstellung',
          name: 'meinbetrieb.darstellung',
          component: require('~/pages/meinbetrieb/darstellung.vue').default
        },
        {
          path: 'impressum',
          name: 'meinbetrieb.impressum',
          component: require('~/pages/meinbetrieb/impressum.vue').default
        }
      ]
    }
  ]),

  // Guest routes.
  ...guestGuard([
    {
      path: '/login',
      name: 'login',
      component: require('~/pages/auth/login.vue').default
    },
    {path: '/anmeldung', redirect: '/anmelden'},
    {
      path: '/anmelden',
      name: 'register',
      component: require('~/pages/auth/register.vue').default
    },
    {
      path: '/password/reset',
      name: 'password.request',
      component: require('~/pages/auth/password/email.vue').default
    },
    {
      path: '/password/reset/:token',
      name: 'password.reset',
      component: require('~/pages/auth/password/reset.vue').default
    }
  ]),
  // {
  //   path: '/innungbetriebe/:slug?/:page?',
  //   name: 'innung',
  //   component: require('~/pages/innung/InnungStart.vue')
  // },
  // {
  //   path: '/innung/:slug',
  //   name: 'Innung',
  //   component: require('~/pages/innung/InnungProfil.vue')
  // },
  {
    path: '/mitmachen',
    name: 'Mitmachen',
    component: require('~/pages/mitmachen.vue').default
  },
  {
    path: '/innung/:slug?/:page?',
    name: 'Innung',
    component: require('~/pages/innung/InnungStart.vue').default
  },

  {
    path: '/anfragenstatus/:id',
    name: 'anfragenstatus',
    component: require('~/pages/meineanfragen/anfragenstatus.vue').default
  },

  {
    path: '/:landing/:stadt?/:page?',
    name: 'Landing',
    component: require('~/pages/landing/landing.vue').default
  },

  // problem mit laravel routea
  {path: '/404', name: '404', component: require('~/pages/errors/404.vue').default },
  {path: '*', redirect: '/404'}

  // { path: '*', component: require('~/pages/errors/404.vue') }
]
